export default __webpack_public_path__ + "static/media/roof.69ae8c9f.png";